import { Card, Empty } from 'antd';
import React, { useCallback } from 'react';

import type { FilterListItemsProps, RenderContentProps } from '../../types/filter-list';
import FilterListItemContent from '../FilterListItemContent';
import FilterListItemSeperator from '../FilterListItemSeperator';
import NestedLevel from '../NestedLevel';
import styles from './FilterListItems.module.scss';

export default function FilterListItems({
  filters,
  operator,
  textOnly,
  canEdit = true,
}: FilterListItemsProps) {
  const renderFilterContent = useCallback((props: RenderContentProps) => {
    const { filters: nestedFilters, operator: nestedOperator, canEdit: nestedCanEdit } = props;
    return (
      <FilterListItems
        filters={nestedFilters}
        operator={nestedOperator}
        textOnly={textOnly}
        canEdit={nestedCanEdit}
      />
    );
  }, [textOnly]);

  if (!filters.length) {
    return (
      <Empty
        className={styles.empty}
        description="No Search Criteria Added Yet"
      />
    );
  }

  if (textOnly) {
    return filters.map((item, index) => {
      if (item.type === 'level') {
        return (
          <NestedLevel
            key={`level-${item.level}`}
            level={item}
            canEdit={canEdit}
            renderContent={renderFilterContent}
          />
        );
      }
      return (
        <FilterListItemContent
          filter={item}
          index={index}
          renderType="text"
          key={item.id}
          canEdit={canEdit}
        />
      );
    });
  }

  return (
    <div className={styles.filterListItems}>
      {filters.map((item, index) => {
        if (item.type === 'level') {
          return (
            <React.Fragment key={`level-${item.level}`}>
              <NestedLevel
                level={item}
                canEdit={canEdit}
                renderContent={renderFilterContent}
              />
              {index !== filters.length - 1 && (
                <FilterListItemSeperator operator={operator} />
              )}
            </React.Fragment>
          );
        }

        return (
          <div key={item.id} className={styles.filterListItem}>
            <Card
              className={styles.filterCardDashed}
              classNames={{
                body: styles.filterCardBody,
              }}
            >
              {index === 0 ? 'When' : operator}
            </Card>
            <Card
              className={styles.filterCard}
              classNames={{
                body: styles.filterCardBody,
              }}
            >
              <FilterListItemContent filter={item} index={index} canEdit={canEdit} />
            </Card>
          </div>
        );
      })}
    </div>
  );
}
